import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { app, db } from "../../../firebaseConfig";
import LoadingButton from "../../Commons/loadingButton";
import Alert from '@mui/material/Alert';

export default function SignIn() {
  // Inputs
  const [mynumber, setnumber] = useState("");
  const [correctNumber, setCorrectNumber] = useState(false);
  const [newNumber, setNewNumber] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("user") || null);
  const isLoggedIn = useRef(Boolean(userData));

  useEffect(() => {
    console.log("isLoggedIn Login", isLoggedIn.current)
    if (isLoggedIn.current) navigate("/home");
  }, [isLoggedIn.current])

  const handleSetNumber = (e) => {
    let updatedNumber = e.target.value;
    setnumber(updatedNumber);
    if (updatedNumber === "" || updatedNumber.length < 10) {
      setCorrectNumber(true);
    } else {
      setCorrectNumber(false);
    }
  }

  const saveUserDetails = async () => {
    console.log("save user ---- ", mynumber);
    const docSnap = await getDoc(doc(db, "userDetails", `+91${mynumber}`));
    // docSnap, docSnap.exists(),
    if (docSnap.exists()) {
      console.log("save user data ", docSnap.data());
      localStorage.setItem("user", JSON.stringify(docSnap.data()));
      navigate(`/profile/+91${mynumber}/dashboard`);
    } else {
      console.log("doc doesnt exist..redirecting to signup");
      navigate("/signup");
    }
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography
          component="h5"
          variant="h5"
          style={{
            fontSize: 15,
            marginTop: "1em",
            fontWeight: "600",
          }}
        >
          Sign in
        </Typography>
        <Box sx={{ mt: 5, my: 8, minWidth: 300 }}>
          <div>
            {correctNumber && <Alert severity="error">Number is not valid </Alert>}
            {newNumber && <Alert severity="error">You are not registered with this number. Please sign-up first. </Alert>}
            <TextField
              id="phone"
              label="Phone"
              fullWidth
              placeholder="1234567890"
              variant="outlined"
              onChange={handleSetNumber}
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
              }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ mt: 2 }}>
                {/* Remove OTP-related code */}
              </Box>
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 4, mb: 2 }}
                onClick={saveUserDetails}
              >
                Sign in
              </Button>
            </Box>
          </div>
          <Box justifyContent="center" sx ={{ mt: 6 }}>
            <Box item>
              <Link
                href="/signup"
                variant="body2"
                sx={{
                  textAlign: "center",
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                {"Don't have an account?"}
                <>&nbsp;</>{" "}
                <span style={{ fontWeight: "bold" }}>Sign Up</span>
              </Link>
            </Box>
          </Box>
          {/* <CopyrightFooter sx={{ mt: 15 }} /> */}
        </Box>
      </Box>
    </Box>
  );
}